import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';
import { Paper, RaisedButton, TextField } from 'material-ui';
import logo from '../../../images/c3Link-Logo-horizontal-500.png';
import { injectIntl } from 'react-intl';
import { APP_VERSION } from '../../../constants/constants';
import RegionSelector from '../../widgets/region-selector/region-selector';

const LoginPage = (props) => (
  <div id="login-form">
    <div style={styles.boxContainer}>
      <Paper style={styles.paper}>
        <div style={styles.logoContainer}>
          <img style={{ height: 90 }} src={logo} alt="C3 Link" />
        </div>
        {props.errorMessage ? (
          <div>
            <p style={styles.errorMessage}>* {props.errorMessage}</p>
          </div>
        ) : null}
        <form onSubmit={props.handleSubmit}>
          <TextField
            name="username"
            hintText="Username"
            floatingLabelText={props.intl.formatMessage({ id: 'username' })}
            fullWidth
          />
          <TextField
            name="password"
            hintText="Password"
            floatingLabelText={props.intl.formatMessage({ id: 'password' })}
            fullWidth
            type="password"
          />
          <div style={styles.buttonsContainer}>
            {props.isRegionSelectionEnabled ? <RegionSelector /> : null}
            <RaisedButton
              label={props.intl.formatMessage({ id: 'login' })}
              primary
              style={styles.boxBtn}
              type="submit"
            />
          </div>
        </form>
      </Paper>
      <div>
        <h6 style={styles.version}>{`${props.intl.formatMessage({
          id: 'version'
        })}: ${APP_VERSION}`}</h6>
      </div>
    </div>
  </div>
);

LoginPage.propTypes = {
  errorMessage: PropTypes.string,
  handleSubmit: PropTypes.func
};

export default injectIntl(LoginPage);
